import styled from "styled-components";
import Responsable from "../../../Responsable";

const EverOn = () => {
  const srcRoot = '/image/webp/project/everon/content';
  const gifSrcRoot = '/image/gif';

  return <>
    <Responsable
      pc={
        <ContentContainer>
          {new Array(3).fill(1).map((_, index) => <img key={`pc-${index}`} src={`${srcRoot}/everon-pc-${index + 1}.png`} width={'100%'} />)}
          <GifSectionContainer>
            <div className="gif-inner">
              <div className="gif-container left">
                <img src={`${gifSrcRoot}/everon-1.gif`} width={'100%'} />
              </div>
              <div className="gif-container right">
                <div className="top">
                  <img src={`${gifSrcRoot}/everon-2.gif`} width={'100%'} />
                </div>
                <div className="bottom">
                  <img src={`${gifSrcRoot}/everon-3.gif`} width={'100%'} />
                </div>
              </div>
            </div>
          </GifSectionContainer>
          {new Array(3).fill(1).map((_, index) => <img key={`pc-${index + 5}`} src={`${srcRoot}/everon-pc-${index + 5}.png`} width={'100%'} />)}
        </ContentContainer>
      }
      tablet={<ContentContainer>
        {new Array(3).fill(1).map((_, index) => <img key={`tab-${index}`} src={`${srcRoot}/everon-tablet-${index + 1}.png`} width={'100%'} />)}
        <GifSectionContainer className="tablet">
          <div className="gif-inner">
            <div className="gif-container left">
              <img src={`${gifSrcRoot}/everon-1.gif`} width={'100%'} />
            </div>
            <div className="gif-container right">
              <div className="top">
                <img src={`${gifSrcRoot}/everon-2.gif`} width={'100%'} />
              </div>
              <div className="bottom">
                <img src={`${gifSrcRoot}/everon-3.gif`} width={'100%'} />
              </div>
            </div>
          </div>
        </GifSectionContainer>
        {new Array(3).fill(1).map((_, index) => <img key={`tab-${index + 5}`} src={`${srcRoot}/everon-tablet-${index + 5}.png`} width={'100%'} />)}
      </ContentContainer>

      }
      mobile={<ContentContainer>
        {new Array(3).fill(1).map((_, index) => <img key={`mo-${index}`} src={`${srcRoot}/everon-mobile-${index + 1}.png`} width={'100%'} />)}
        <GifSectionContainer className="mobile">
          <div className="gif-inner">
            <div className="gif-container left">
              <img src={`${gifSrcRoot}/everon-1.gif`} width={'100%'} />
            </div>
            <div className="gif-container right">
              <div className="top">
                <img src={`${gifSrcRoot}/everon-2.gif`} width={'100%'} />
              </div>
              <div className="bottom">
                <img src={`${gifSrcRoot}/everon-3.gif`} width={'100%'} />
              </div>
            </div>
          </div>
        </GifSectionContainer>
        {new Array(3).fill(1).map((_, index) => <img key={`mo-${index + 5}`} src={`${srcRoot}/everon-mobile-${index + 5}.png`} width={'100%'} />)}
      </ContentContainer>}
    />
  </>;
};

export { EverOn };

const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;

  img {
    margin-bottom: -1px;
    object-fit: cover;
  }
`;

const GifSectionContainer = styled.div`
  width: 100%;
  padding: 120px 0px;
  background: #D8F3FF;

  .gif-inner {
    display: flex;
    gap: 40px;
    align-items: center;
    justify-content: center;
    max-width: 60%;
    margin: 0 auto;
  }

  .gif-container {
    flex: 1;
    overflow: hidden;

    &.left {
      display: flex;
      align-items: flex-end;
      justify-content: center;
      width: 100%;
      aspect-ratio: 580/800;
      background: #fff;
      border-radius: 42px;
    }

    &.right {
      display: flex;
      flex-direction: column;
      gap: 40px;
      width: 100%;
      aspect-ratio: 580/1200;

      .top {
        width: 100%;
        aspect-ratio: 580/800;
        border-radius: 42px;
        overflow: hidden;
      }
      .bottom {
        width: 100%;
        aspect-ratio: 580/800;
        border-radius: 42px;
        overflow: hidden;
      }
    }
  }

  &.tablet {
    padding: 80px 48px;

    .gif-inner {
      flex-direction: column;
      gap: 40px;
      max-width: 100%;
    }
  
    .gif-container {
      &.left {
        aspect-ratio: 620/800;
      }
    }
  }

  &.mobile {
    padding: 40px 24px;

    .gif-inner {
      flex-direction: column;
      gap: 40px;
      max-width: 100%;
    }
  
    .gif-container {
      &.left {
        aspect-ratio: 327.00/366.39;
        border-radius: 24px;
      }

      .top, .bottom {
        border-radius: 24px;
      }
    }
  }
`;